const SEPARATOR = '@';

export function getEmailDomain(email: string): string | undefined {
  if (!email || !email.includes(SEPARATOR)) {
    return undefined;
  }

  return email.toLowerCase().split(SEPARATOR)[1];
}
